<template>
  <video
    ref="videoRef"
    autoplay
    muted
    loop
    playsinline
    width="552"
    height="294"
    :src="heroVideo"
    v-bind="$attrs"
    @click="togglePlay"
  />
</template>

<script setup>
import { ref, computed } from 'vue'

import { useSessionValues } from '@/composables/useSessionValues'

import defaultStudioPlusHeroVideo from '@/assets/videos/studio-plus-landing/hero/tBS+_US.mp4'
import studioPlusHeroVideoDe from '@/assets/videos/studio-plus-landing/hero/tBS+_DE.mp4'
import studioPlusHeroVideoGr from '@/assets/videos/studio-plus-landing/hero/tBS+_GR.mp4'
import studioPlusHeroVideoGb from '@/assets/videos/studio-plus-landing/hero/tBS+_UK.mp4'
import studioPlusHeroVideoEsEs from '@/assets/videos/studio-plus-landing/hero/tBS+_ES.mp4'
import studioPlusHeroVideoEsMx from '@/assets/videos/studio-plus-landing/hero/tBS+_MX.mp4'
import studioPlusHeroVideoFr from '@/assets/videos/studio-plus-landing/hero/tBS+_FR.mp4'
import studioPlusHeroVideoIt from '@/assets/videos/studio-plus-landing/hero/tBS+_IT.mp4'
import studioPlusHeroVideoJp from '@/assets/videos/studio-plus-landing/hero/tBS+_JA.mp4'
import studioPlusHeroVideoNl from '@/assets/videos/studio-plus-landing/hero/tBS+_NL.mp4'
import studioPlusHeroVideoPl from '@/assets/videos/studio-plus-landing/hero/tBS+_PL.mp4'
import studioPlusHeroVideoPtBr from '@/assets/videos/studio-plus-landing/hero/tBS+_BR.mp4'
import studioPlusHeroVideoPtPt from '@/assets/videos/studio-plus-landing/hero/tBS+_PT.mp4'
import studioPlusHeroVideoTr from '@/assets/videos/studio-plus-landing/hero/tBS+_TR.mp4'

defineOptions({ inheritAttrs: false })

const { language } = useSessionValues()

const videosByLocale = {
  'en-US': defaultStudioPlusHeroVideo,
  'de-DE': studioPlusHeroVideoDe,
  'el-GR': studioPlusHeroVideoGr,
  'en-GB': studioPlusHeroVideoGb,
  'es-ES': studioPlusHeroVideoEsEs,
  'es-MX': studioPlusHeroVideoEsMx,
  'fr-FR': studioPlusHeroVideoFr,
  'it-IT': studioPlusHeroVideoIt,
  'ja-JP': studioPlusHeroVideoJp,
  'nl-NL': studioPlusHeroVideoNl,
  'pl-PL': studioPlusHeroVideoPl,
  'pt-BR': studioPlusHeroVideoPtBr,
  'pt-PT': studioPlusHeroVideoPtPt,
  'tr-TR': studioPlusHeroVideoTr,
}

const heroVideo = computed(() => videosByLocale[language.value] ?? defaultStudioPlusHeroVideo)

const videoRef = ref(null)
const togglePlay = () => {
  if (!videoRef.value) return
  videoRef.value.paused ? videoRef.value.play() : videoRef.value.pause()
}
</script>

